import { render, staticRenderFns } from "./CessaoNew.vue?vue&type=template&id=3e1a856c&scoped=true&"
import script from "./CessaoNew.vue?vue&type=script&lang=js&"
export * from "./CessaoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1a856c",
  null
  
)

export default component.exports